import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useMatterRequestCurrencySelect } from './useMatterRequestCurrencySelect';

interface MatterRequestCurrencySelectProps {
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the currency list is only fetched where the field is rendered. It renders
 * the trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const MatterRequestCurrencySelect = ({
  onOpenPicker,
  onClear,
}: Readonly<MatterRequestCurrencySelectProps>) => {
  const { t } = useTranslation();
  const select = useMatterRequestCurrencySelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('matterRequest:currency')}
      placeholder={t('matterRequest:selectCurrency')}
      searchPlaceholder={t('matterRequest:searchCurrencies')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-field="currency"
      data-testid="select-currency-button"
    />
  );
};

export default MatterRequestCurrencySelect;
